<template>
  <!-- 弹框 -->
  <Modal
    v-model="editListModal"
    width="700"
    title="充值"
    :mask-closable="false"
    :loading="loading"
    @on-ok="editList('editListForm')"
  >
  <Form
    ref="editListForm"
    label-position="right"
    :label-width="120"
    :rules="ruleValidate"
    :model="editListForm"
  >
    <div class="" style="line-height:35px;text-align: center;border: 1px solid #ededed; margin: 0 60px 20px">
      <p>对公账号：{{agentMsg.name}}&nbsp;&nbsp;{{agentMsg.bank_name}}&nbsp;&nbsp;{{agentMsg.bank_account}}</p>
    </div>
    <FormItem label="流水单号"
      prop="flow_no"
      label-for="flow_no"
    >
      <Input
        style="width: 89%"
        placeholder="请输入流水单号"
        element-id="flow_no"
        v-model="editListForm.flow_no"
      ></Input>
    </FormItem>
    <FormItem label="返佣凭证"
      label-for="img_url_list"
      prop="img_url_list"
    >
    <UploadImg
      :defaultList="defaultImgList"
      @on-change="editListForm.img_url_list = $event">
    </UploadImg>
    </FormItem>
</Form>
</Modal>
</template>

<script>
import UploadImg from '@/components/UploadImg'

export default {
  components: {
    UploadImg
  },
  props: {
    agentId: {
      type: Number,
      required: true
    },
    ApplyId: {
      type: Number,
      required: true
    },
    editModal: {
      type: Boolean,
      required: true
    }
  },
  data () {
    return {
      listLoading: false,
      loading: true,
      defaultImgList: [],
      editListModal: this.editModal,
      agentMsg: {},
      editListForm: {
        flow_no: '',
        img_url_list: []
      },
      ruleValidate: {
        flow_no: [
          { required: true, message: '请输入流水单号', trigger: 'blur' }
        ],
        img_url_list: [
          { required: true, type: 'array', message: '最少提交一张开票凭证图片', trigger: 'change' }
        ]
      }
    }
  },
  watch: {
    editModal (val) {
      this.editListModal = val
      if (val) {
        this.getAgentMsg()
        this.reload()
      }
    },
    editListModal (val) {
      if (!val) {
        this.$emit('backeditModal')
      }
    }
  },
  methods: {
    getAgentMsg () {
      this.$http.get(`/agent/account/info?id=${this.agentId}`).then(res => {
        this.agentMsg = res.data
      })
    },
    editList (val) {
      setTimeout(() => {
        this.loading = false
        setTimeout(() => { this.loading = true }, 100)
      }, 3000)
      this.$refs[val].validate((valid) => {
        if (valid) {
          for (let obj in this.editListForm) {
            if (obj === 'img_url_list') {
              let arr = []
              this.editListForm[obj].forEach(val => {
                arr.push(val.url)
              })
              this.editListForm[obj] = arr
            }
          }
          let data = {
            id: this.ApplyId,
            ...this.editListForm
          }
          let url = '/balance/handle'
          this.$http.put(url, data).then(res => {
            if (res.success) {
              this.$Message.success('转账成功')
              this.editListModal = false
              this.$emit('callback')
            } else {
              this.$Message.error(res.message)
            }
          })
        }
      })
    },
    reload () {
      this.defaultImgList = []
      this.editListForm = {
        flow_no: '',
        img_url_list: []
      }
    }
  }
}
</script>

<style lang="css">
</style>



// WEBPACK FOOTER //
// src/pages/handle/balanceHandle/Transfer.vue